import {Question} from '@/lib/Question';
import {ResponseGroup} from '@/lib/ResponseGroup';

export default class Response {
    public additionalIndex: number = 1;
    constructor(
        public question: Question,
        public responseGroup: ResponseGroup,
        public value: string = '',
        public comment: string = '',
        public valueId: number = 0,
        public id: any = 0,
        public customData: any = {},
        ) {
        if (null === customData || typeof undefined === typeof customData) {
            this.customData = {};
        }
    }


    public getCustomDataElement(index: string|number){
        return this.customData[index];
    }

    public setCustomDataElement(index: string|number, value: any) {
        this.customData[index] = value;
    }
}
